module.exports = __webpack_public_path__ + "img/17.d7414cd.png";